module.exports = __webpack_public_path__ + "static/assets/acf5fa319aeadb1e19cd7e28fef66bde.png";